/* eslint-disable import/prefer-default-export  */

export const FILTERED_SEARCH = {
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues',
  ADMIN_RUNNERS: 'admin/runners',
};
